const SortDescendingIcon = /*#__PURE__*/ [
  ["path", { d: "M15.5 14C15.5 14 19 16.5777 19 17.5C19 18.4223 15.5 21 15.5 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18.5 17.5H12.5C9.21252 17.5 7.56878 17.5 6.46243 16.592C6.25989 16.4258 6.07418 16.2401 5.90796 16.0376C5 14.9312 5 13.2875 5 10V3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9 6H19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M9 10H16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export { SortDescendingIcon as default };
//# sourceMappingURL=SortDescendingIcon.js.map
